<div class="navbar" [class.sticky]="true" [class.active]="classApplied">
  <div class="navbar-container">
    <!-- Logo -->
    <a class="navbar-logo" routerLink="/" (click)="closeAllDropdowns()">
      <img class="logo" src="assets/img/logo-signomedico-1.png" alt="signomedico">
    </a>

    <button class="menu-toggle" (click)="toggleClass()">
      <i class="toggle-icon bx bx-menu" *ngIf="!classApplied"></i>
      <i class="toggle-icon bx bx-x" *ngIf="classApplied"></i>
    </button>

    <!-- Menú principal -->
    <nav class="navbar-menu">
      <div class="menu-loading" *ngIf="!flagMenuLoaded">
        <h4>Cargando menú...</h4>
        <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
      </div>

      <ul class="menu-list" *ngIf='flagMenuLoaded'>
        <ng-container *ngFor="let item of buildMenu">
          <!-- Items sin submenú (o el Panel Administrativo, que es link simple) -->
          <li *ngIf="item.descendants.length === 0 || esPanelAdministrativo(item)" class="menu-item">
            <a [routerLink]="item.menu.redirectTo"
               class="menu-link"
               routerLinkActive="active"
               [routerLinkActiveOptions]="{exact: true}"
               (click)="toggleClass(); closeAllDropdowns()">
              {{ item.menu.name }}
            </a>
          </li>

          <!-- Items con submenú -->
          <li *ngIf="item.descendants.length > 0 && !esPanelAdministrativo(item)"
              class="menu-item has-dropdown"
              [class.dropdown-open]="isDropdownOpen(item.menu.name)">
            
            <a href="javascript:void(0)" 
               class="menu-link dropdown-trigger"
               (mouseenter)="onDropdownMouseEnter(item.menu.name)"
               (mouseleave)="onDropdownMouseLeave(item.menu.name)">
              {{ item.menu.name }}
              <i class='dropdown-icon bx bx-chevron-down'></i>
            </a>

            <!-- Dropdown normal -->
            <ul class="dropdown-menu" 
                *ngIf="item.menu.name !== 'Administración' && item.menu.name !== 'Mi Cuenta'"
                (mouseenter)="onDropdownMenuMouseEnter(item.menu.name)"
                (mouseleave)="onDropdownMouseLeave(item.menu.name)">
              <li *ngFor="let descendant of item.descendants" class="dropdown-item">
                <a [routerLink]="descendant.redirectTo"
                   class="dropdown-link"
                   routerLinkActive="active"
                   [routerLinkActiveOptions]="{exact: true}"
                   (click)="toggleClass(); closeAllDropdowns()">
                  {{ descendant.name }}
                </a>
              </li>
            </ul>

            <!-- Dropdown especial para Mi Cuenta (CORREGIDO) -->
            <div class="dropdown-menu admin-grid" 
                 *ngIf="item.menu.name === 'Mi Cuenta'"
                 (mouseenter)="onDropdownMenuMouseEnter(item.menu.name)"
                 (mouseleave)="onDropdownMouseLeave(item.menu.name)">
              <div class="admin-container">
                <div class="admin-grid-layout">
                  <div *ngFor="let descendant of item.descendants" class="admin-grid-item">
                    <a [routerLink]="descendant.redirectTo"
                       class="admin-grid-link"
                       routerLinkActive="active"
                       [routerLinkActiveOptions]="{exact: true}"
                       (click)="toggleClass(); closeAllDropdowns()">
                      <div class="admin-icon">
                        <i [class]="getMiCuentaIcon(descendant.name)"></i>
                      </div>
                      <span class="admin-label">{{ descendant.name }}</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <!-- Dropdown especial para Administración -->
            <div class="dropdown-menu admin-grid" 
                 *ngIf="item.menu.name === 'Administración'"
                 (mouseenter)="onDropdownMenuMouseEnter(item.menu.name)"
                 (mouseleave)="onDropdownMouseLeave(item.menu.name)">
              <div class="admin-container">
                <div class="admin-grid-layout">
                  <div *ngFor="let descendant of item.descendants" class="admin-grid-item">
                    <a [routerLink]="descendant.redirectTo"
                       class="admin-grid-link"
                       routerLinkActive="active"
                       [routerLinkActiveOptions]="{exact: true}"
                       (click)="toggleClass(); closeAllDropdowns()">
                      <div class="admin-icon">
                        <i [class]="descendant.icon"></i>
                      </div>
                      <span class="admin-label">{{ descendant.name }}</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ng-container>
      </ul>
    </nav>

    <!-- Área de usuario -->
    <div class="navbar-user">
      <!-- Mis Mensajes (Notificaciones Bell) -->
      <a
        [routerLink]="'/mis-mensajes'"
        class="nav-icon position-relative"
        title="Mis Mensajes"
        style="display: inline-flex; align-items: center; margin-right: 15px; position: relative; text-decoration: none; color: inherit; cursor: pointer;"
      >
        <mat-icon style="font-size: 1.5rem; color: #8E1F3F;">notifications</mat-icon>
        <span *ngIf="unreadNotificationsCount > 0" class="badge-count" style="position: absolute; top: -5px; right: -5px; background: #ff3b30; color: white; border-radius: 50%; padding: 2px 6px; font-size: 0.7rem; font-weight: bold; line-height: 1;">
          {{ unreadNotificationsCount }}
        </span>
      </a>

      <div class="user-welcome" *ngIf="flagUsuarioCargado && usuario">
        <span class="welcome-text">Bienvenido, {{ usuario.apellidoPersona }} {{ usuario.nombrePersona }}</span>
      </div>
      
      <button class="logout-btn" *ngIf="flagMenuLoaded" (click)="logout()">
        <i class="logout-icon fas fa-power-off"></i>
        <span class="logout-text">Salir</span>
      </button>
    </div>
  </div>
</div>